export * from '@fhs/routing/src/routes/(auth)/_layout';
export { default } from '@fhs/routing/src/routes/(auth)/_layout';
